module.exports = __webpack_public_path__ + "static/media/team-jason.f2811060.png";